/**
 * Kullanıcının bot penceresine yazdığı toplantı bağlantısını standart biçime çevirir —
 * sunucudaki `web/lib/bots/meeting-link.ts` ile aynı kurallar (`npm run test:prefs` ikisini
 * aynı örneklerle sınar).
 *
 * Kabul edilenler: tam bağlantı, `https://` olmadan bağlantı, yalnızca Meet kodu
 * (`xmc-tnwb-pza`), bunların `?authuser=1` gibi ekli hâlleri ve bağlantının geçtiği davet
 * metni. Meet `https://meet.google.com/<kod>` olur: `/meet/` öneki ve `authuser` botu
 * yanıltır. Zoom ve Teams'te sorgu korunur (`pwd` toplantı şifresidir). Alan adı listede
 * değilse null: bot başka adrese gitmesin.
 */

const MEET_HOST = 'meet.google.com';
const MEET_CODE = /^[a-z]{3}-[a-z]{4}-[a-z]{3}$/;
const BARE_MEET_CODE = /^([a-z]{3}-[a-z]{4}-[a-z]{3})\/?(?:[?#].*)?$/i;
const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:\/\//i;

function isMeetingHost(host: string): boolean {
  return (
    host === MEET_HOST ||
    host === 'zoom.us' ||
    host.endsWith('.zoom.us') ||
    host === 'teams.microsoft.com' ||
    host.endsWith('.teams.microsoft.com') ||
    host === 'teams.live.com'
  );
}

function normalizeToken(token: string): string | null {
  // Yapıştırılan metindeki çevre işaretleri: <https://…>, (…), sondaki nokta.
  const value = token.replace(/^[<(["']+/, '').replace(/[>)\]"'.,;:]+$/, '');
  const bare = BARE_MEET_CODE.exec(value);
  if (bare) return `https://${MEET_HOST}/${bare[1].toLowerCase()}`;

  let url: URL;
  try {
    url = new URL(HAS_SCHEME.test(value) ? value : `https://${value}`);
  } catch {
    return null;
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
  if (url.username || url.password) return null;
  const host = url.hostname.toLowerCase();
  if (!isMeetingHost(host)) return null;

  if (host === MEET_HOST) {
    const segments = url.pathname.split('/').filter(Boolean);
    const code = segments.map((segment) => segment.toLowerCase()).find((segment) => MEET_CODE.test(segment));
    if (code) return `https://${MEET_HOST}/${code}`;
    // Takma adlı toplantı (Workspace): kod yok, yönlendirme bağlantısı olduğu gibi kalır.
    if (segments[0] !== 'lookup' || !segments[1]) return null;
  }

  url.protocol = 'https:';
  url.port = '';
  return url.href;
}

/** Standart bağlantı; toplantı bağlantısı değilse null. */
export function normalizeMeetingUrl(input: unknown): string | null {
  if (typeof input !== 'string') return null;
  for (const token of input.trim().slice(0, 4000).split(/\s+/)) {
    const url = token ? normalizeToken(token) : null;
    if (url) return url;
  }
  return null;
}
